<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="webinar-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🎙️ LIVE &amp; ON-DEMAND</div>
      <h1>Learn from<br><span style="color:#fda4af;">HR Experts Live</span></h1>
      <p>Free weekly webinars, deep-dive workshops, and a growing library of on-demand sessions — hosted by practitioners, for practitioners.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-white">Register for Next Webinar</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Browse On-Demand Library</a>
      </div>
    </div>
    <div>
      <div class="live-widget">
        <div class="live-widget__badge"><div class="live-widget__dot"></div>LIVE NOW</div>
        <div class="live-widget__title">Navigating the New Overtime Rules: What HR Must Do Before Q3</div>
        <div class="live-widget__host">Hosted by Rachel Kim, VP People Operations</div>
        <div class="live-widget__stats">
          <span><span class="live-widget__stat-num">1,248</span> watching</span>
          <span><span class="live-widget__stat-num">342</span> questions</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- UPCOMING -->
<section class="upcoming-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📅 Coming Up</span>
      <h2 class="sec-h2">Upcoming<br><span class="gradient-text">Webinars</span></h2>
      <p class="sec-sub">All sessions are free to attend live. Registered attendees receive the full recording automatically.</p>
    </div>
    <div class="upcoming-grid">
      <div class="webinar-card">
        <div class="webinar-card__thumb" style="background:linear-gradient(135deg,#4a0011,#e11d48);">📊</div>
        <div class="webinar-card__body">
          <div class="webinar-card__date">Thu, Jun 19 · 11am IST</div>
          <div class="webinar-card__title">The 2025 HR Compliance Audit: What's Changed and What to Do Now</div>
          <div class="webinar-card__host">Hosted by James Thornton, Head of Compliance</div>
          <div class="webinar-card__footer">
            <span class="webinar-card__seats">142 registered</span>
            <a href="#" class="btn btn-primary" style="font-size:12px;padding:6px 16px;background:#e11d48;">Register</a>
          </div>
        </div>
      </div>
      <div class="webinar-card">
        <div class="webinar-card__thumb" style="background:linear-gradient(135deg,#1e1b4b,#6366f1);">🤖</div>
        <div class="webinar-card__body">
          <div class="webinar-card__date">Tue, Jun 24 · 2pm IST</div>
          <div class="webinar-card__title">Using AI to Cut Time-to-Hire by 50%: A Live Demonstration</div>
          <div class="webinar-card__host">Hosted by Priya Agarwal, VP Product</div>
          <div class="webinar-card__footer">
            <span class="webinar-card__seats">287 registered</span>
            <a href="#" class="btn btn-primary" style="font-size:12px;padding:6px 16px;background:#e11d48;">Register</a>
          </div>
        </div>
      </div>
      <div class="webinar-card">
        <div class="webinar-card__thumb" style="background:linear-gradient(135deg,#052e16,#15803d);">🌍</div>
        <div class="webinar-card__body">
          <div class="webinar-card__date">Wed, Jul 2 · 10am IST</div>
          <div class="webinar-card__title">Hiring Globally Without the Headaches: EOR vs Entity Setup</div>
          <div class="webinar-card__host">Hosted by Sara Lin, Global HR Lead</div>
          <div class="webinar-card__footer">
            <span class="webinar-card__seats">96 registered</span>
            <a href="#" class="btn btn-primary" style="font-size:12px;padding:6px 16px;background:#e11d48;">Register</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ON DEMAND -->
<section class="ondemand-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📼 On-Demand Library</span>
      <h2 class="sec-h2">Watch Any Time<br><span class="gradient-text">At Your Pace</span></h2>
    </div>
    <div class="ondemand-grid">
      <div class="ondemand-card"><div class="ondemand-card__thumb">💰</div><div class="ondemand-card__body"><div class="ondemand-card__title">End-to-End Payroll Automation with NeoHRMZ</div><div class="ondemand-card__dur">⏱ 52 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🎯</div><div class="ondemand-card__body"><div class="ondemand-card__title">Building a High-Converting ATS Pipeline</div><div class="ondemand-card__dur">⏱ 48 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">📈</div><div class="ondemand-card__body"><div class="ondemand-card__title">OKR Setting That Actually Works</div><div class="ondemand-card__dur">⏱ 38 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🔐</div><div class="ondemand-card__body"><div class="ondemand-card__title">HR Data Privacy in Practice</div><div class="ondemand-card__dur">⏱ 41 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🏭</div><div class="ondemand-card__body"><div class="ondemand-card__title">Manufacturing Workforce Management</div><div class="ondemand-card__dur">⏱ 55 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🏥</div><div class="ondemand-card__body"><div class="ondemand-card__title">Clinical Staffing &amp; HIPAA Compliance</div><div class="ondemand-card__dur">⏱ 44 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🌍</div><div class="ondemand-card__body"><div class="ondemand-card__title">Cross-Border Payroll: The Full Picture</div><div class="ondemand-card__dur">⏱ 60 min</div></div></div>
      <div class="ondemand-card"><div class="ondemand-card__thumb">🏠</div><div class="ondemand-card__body"><div class="ondemand-card__title">Building Remote-First Culture &amp; Policy</div><div class="ondemand-card__dur">⏱ 35 min</div></div></div>
    </div>
  </div>
</section>

<!-- SPEAKERS -->
<section class="speakers-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🎤 Expert Speakers</span>
      <h2 class="sec-h2">Learn from<br><span class="gradient-text">the Best</span></h2>
    </div>
    <div class="speakers-grid">
      <div class="speaker-card"><div class="speaker-card__avatar">P</div><div class="speaker-card__name">Priya Agarwal</div><div class="speaker-card__role">VP Product, NeoHRMZ</div></div>
      <div class="speaker-card"><div class="speaker-card__avatar">J</div><div class="speaker-card__name">James Thornton</div><div class="speaker-card__role">Head of Compliance</div></div>
      <div class="speaker-card"><div class="speaker-card__avatar">R</div><div class="speaker-card__name">Rachel Kim</div><div class="speaker-card__role">VP People Operations</div></div>
      <div class="speaker-card"><div class="speaker-card__avatar">S</div><div class="speaker-card__name">Sara Lin</div><div class="speaker-card__role">Global HR Lead</div></div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="webinar-cta">
  <div class="container-wrapper">
    <h2 class="webinar-cta__h2">Never Miss a Live Session</h2>
    <p class="webinar-cta__p">Subscribe to our webinar calendar and get reminders for every upcoming session — plus instant access to the full on-demand library.</p>
    <div class="webinar-cta__actions">
      <a href="#" class="btn btn-white">Subscribe to Calendar</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Browse All Sessions</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>